import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import useMeasure from 'react-use/lib/useMeasure';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { DesktopHeaderContent } from 'components/DesktopHeader/DesktopHeaderContent';
import { SearchProgressBar } from 'components/SearchProgressBar';
import { motion, useScroll } from 'framer-motion';
import { getIsTopHeaderHidden, getSearchDesktopHeaderHeight } from 'modules/search/selectors';
import { setIsTopHeaderHidden, setSearchDesktopHeaderHeight } from 'modules/search/slice';
import { COMPACT_HEADER_TOP_HEIGHT } from '@daedalus/atlas/Header';
import { useBodyScrollLockObserver } from '@daedalus/atlas/Overlay/useBodyScrollLock';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
interface Props {
  /** Whether to show the search form in the header */
  hasSearchForm?: boolean;
  /** Whether to show the filters bar in the header */
  hasFilters?: boolean;
  /** Whether the header should be fixed or not */
  isFixed?: boolean;
  /** Whether the search progress bar should appear or not */
  hasSearchProgressBar?: boolean;
  /** Custom component to override default search box */
  customSearchBox?: React.ReactElement;
}
const _exp = /*#__PURE__*/() => ({
  scrollBarGap
}) => scrollBarGap;
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h1mylj5l",
  propsAsIs: false,
  vars: {
    "h1mylj5l-0": [_exp(), "px"]
  }
});
const _exp2 = /*#__PURE__*/() => ({
  searchDesktopHeaderHeight
}) => searchDesktopHeaderHeight;
const HeaderSpacer = /*#__PURE__*/styled('div')({
  name: "HeaderSpacer",
  class: "hltm6dc",
  propsAsIs: false,
  vars: {
    "hltm6dc-0": [_exp2(), "px"]
  }
});
export const DesktopHeader = ({
  hasSearchForm,
  hasFilters = false,
  isFixed = true,
  hasSearchProgressBar = false,
  customSearchBox
}: Props) => {
  const dispatch = useDispatch();
  const {
    brandHasCollapsingHeader
  } = useBrand();
  const searchDesktopHeaderHeight = useSelector(getSearchDesktopHeaderHeight);
  const topHeaderIsHidden = useSelector(getIsTopHeaderHidden);
  const [headerRef, {
    height
  }] = useMeasure();
  const {
    scrollBarGap
  } = useBodyScrollLockObserver();
  const shouldHideHeaderTopOnScroll = brandHasCollapsingHeader && isFixed;
  const topHeaderHeight = COMPACT_HEADER_TOP_HEIGHT;
  const {
    scrollY
  } = useScroll();
  const location = useLocation();
  useEffect(() => {
    if (shouldHideHeaderTopOnScroll) {
      scrollY.on('change', v => {
        if (v > topHeaderHeight) {
          dispatch(setIsTopHeaderHidden(true));
        } else {
          dispatch(setIsTopHeaderHidden(false));
        }
      });
    }
  }, [scrollY, dispatch, shouldHideHeaderTopOnScroll, topHeaderHeight]);
  useEffect(() => {
    if (shouldHideHeaderTopOnScroll) {
      dispatch(setIsTopHeaderHidden(false));
    }
  }, [dispatch, location.pathname, shouldHideHeaderTopOnScroll]);
  useEffect(() => {
    dispatch(setSearchDesktopHeaderHeight(height));
  }, [dispatch, height]);
  return <>
      <motion.div style={{
      position: shouldHideHeaderTopOnScroll ? 'fixed' : 'relative',
      width: '100%'
    }} initial={false} animate={{
      top: topHeaderIsHidden ? -topHeaderHeight : 0
    }}>
        <HeaderWrapper ref={headerRef} scrollBarGap={scrollBarGap} className={cx(isFixed && scrollBarGap > 0 && '__withRightPadding', isFixed && '__isFixed')}>
          <DesktopHeaderContent hasSearchForm={hasSearchForm} hasFilters={hasFilters} customSearchBox={customSearchBox} />
          {hasSearchProgressBar && <SearchProgressBar />}
        </HeaderWrapper>
      </motion.div>

      {isFixed && <HeaderSpacer searchDesktopHeaderHeight={searchDesktopHeaderHeight} />}
    </>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");